import { connect } from 'react-redux';
import { goBack as goBackAction, push as pushAction } from 'react-router-redux';
import TalkDetail from './components/TalkDetail';
import { fetchTalkDetails } from '../Program/actions/programActions';

export const mapStateToProps = (state, props) => {
    let talksInSlot = [];
    const programType =
        state.program.talksById[props.match.params.id].track === 'Hands-on Lab'
            ? state.program.workshopTimeSlotsById
            : state.program.timeSlotsById;
    Object.values(programType).find(timeslot => {
        const talkSlots = Object.values(timeslot.talks);
        const talkSlot = talkSlots.find(slot => slot.some(item => item === props.match.params.id));
        talksInSlot = talkSlot;
        return talkSlot;
    });

    const talks = state.program.talks.filter(talk => talksInSlot.some(item => item === talk.id));

    return {
        talksById: state.program.talksById,
        speakersById: state.speakers.speakersById,
        talks,
        speakers: state.speakers.speakers,
        fetchingProgram: state.program.fetchingProgram
    };
};

export const mapActionCreators = {
    goBackAction,
    pushAction,
    fetchTalkDetails
};

export default connect(
    mapStateToProps,
    mapActionCreators
)(TalkDetail);
